import { splitPlacementPoints } from "../ties.js";
import type { Format, RoundResult } from "./types.js";
import {
  allowanceNote,
  buildScoreMap,
  computeHandicaps,
  holeCount,
  netTotal,
  scoringHoles,
} from "./util.js";

export const strokePlayNet: Format = {
  id: "strokePlayNet",
  name: "Stroke Play (Net)",
  scope: "individual",
  uses: { pointTable: true, handicapAllowance: true },
  entry: "perPlayer",
  defaults: { handicapAllowance: 100 },
  configSchema: {
    type: "object",
    properties: {},
  },
  perHoleSchema: null,

  score({ round, course, players, scores, onlyHoles }): RoundResult {
    const holes = scoringHoles(round, course, onlyHoles);
    const scoreMap = buildScoreMap(scores);
    const handicaps = computeHandicaps(round, course, players);

    const entries = players
      .map((p) => ({ id: p.id, value: netTotal(scoreMap, handicaps, p.id, holes) }))
      .filter((e): e is { id: string; value: number } => e.value != null);

    const points = splitPlacementPoints(entries, round.pointTable, { lowerIsBetter: true });
    const netTotals: Record<string, number> = {};
    for (const e of entries) netTotals[e.id] = e.value;

    const pointsRecord: Record<string, number> = {};
    for (const p of players) pointsRecord[p.id] = points.get(p.id) ?? 0;

    return { roundId: round.id, points: pointsRecord, netTotal: netTotals, provisional: Boolean(onlyHoles) };
  },

  describeRules(round, players, course) {
    const allowance = round.handicapAllowance;
    return [
      `Net stroke play across ${holeCount(round, course)} holes.`,
      `Handicap allowance: ${allowance}%${allowanceNote(round, course)}.`,
      `Points by finishing place: ${round.pointTable.join(", ")}. Ties split the points evenly.`,
      `${players.length} players.`,
    ];
  },
};
